/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js';

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

/**
 * If your application uses the browser animations module, you will need to import the `zone.js`
 * patch for `requestAnimationFrame`.
 */


/**
 * If your application uses the `@angular/platform-webworker`, you will need to import the `zone.js`
 * patch for web workers.
 */


/**
 * If your application uses `@angular/form`'s `onPush` change detection, you will need to import the
 * `zone.js` patch for `MessageChannel`.
 */


/**
 * If your application uses the `@angular/service-worker` package, you will need to import the
 * `zone.js` patch for the service worker.
 */


/**
 * If you need to support older browsers like Internet Explorer 11, you might need to include
 * some additional polyfills. Uncomment the imports below as needed.
 */



import 'src/uuid-polyfill.js';

console.log("[CUSTOM][process.env.NODE_ENV | Current environment is]:", process.env.NODE_ENV);

if (process.env.NODE_ENV === 'production') {
  // Production.
} else {
  // Development and test.
  Error['stackTraceLimit'] = 1000;

}
